import React, { useState } from "react";
import { sendQuery } from "../../service/api/ContactService";
import { TextField } from "@mui/material";
import Button from "../../components/controls/Button";
import { useHistory } from "react-router-dom";

import "./Contact.scss";
import useUser from "../Login/useUser";

export const Contact = () => {

    const { user } = useUser();
    const [formData, setFormData] = useState({ contactName: user.userName, contactEmail: user.email, contactPhone: user.phone, contactQuery: "" })
    const [showForm, setShowForm] = useState(true);

    const handleChange = event => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        })
    }

    const sendForm = () => {
        sendQuery(formData).then();
        setShowForm(false);
    }
    let history = useHistory();
    const redirect = () => {
        history.push({
            pathname: `/score`,
        })
    }

    return (
        <div className="contact">
            <div className="modal-container">
                {showForm ? (
                    <>
                        <div className="contact-container shadow bg-white text-start">
                            <Button className="col close-icon me-2" id="redirect-button" onClick={redirect}>
                                <span ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M14.7.423a.905.905 0 0 0-1.205.066L7.631 6.353 1.766.49a.903.903 0 0 0-1.277 0L.423.562A.903.903 0 0 0 .49 1.766l5.864 5.865L.49 13.495a.903.903 0 0 0 0 1.278l.073.066a.902.902 0 0 0 1.204-.066l5.865-5.867 5.864 5.867a.903.903 0 0 0 1.278 0l.066-.074a.902.902 0 0 0-.066-1.204L8.907 7.631l5.866-5.864a.902.902 0 0 0 0-1.277l-.074-.065.001-.002z" fill="#5C157D" />
                                </svg></span>
                            </Button>
                            <div className="col-11 col-xl-7 col-l-7 col-sm-8 mx-auto contact-headline">
                                <h3>¿En qué podemos ayudarte?</h3>
                            </div>
                            <div className="col-10 col-xl-7 col-l-7 col-sm-8 m-auto">
                                <p>
                                    Completa el formulario inferior con tus dudas y te atenderemos lo antes posible.
                                </p>
                            </div>
                            <div className="col-10 col-xl-7 col-l-7 col-sm-8 mx-auto mb-2">

                                <form>
                                    <TextField
                                        required
                                        name="contactName"
                                        label="Nombre"
                                        variant="outlined"
                                        className="input-text"
                                        value={formData.contactName}
                                        onChange={handleChange}
                                        disabled={true}
                                    />
                                    <TextField
                                        required
                                        name="contactEmail"
                                        label="Email"
                                        variant="outlined"
                                        className="input-text"
                                        value={formData.contactEmail}
                                        onChange={handleChange}
                                        disabled={true}
                                    />
                                    <TextField
                                        required
                                        name="contactPhone"
                                        type="text"
                                        label="Teléfono"
                                        variant="outlined"
                                        className="input-number"
                                        value={formData.contactPhone}
                                        onChange={handleChange}
                                        disabled={true}
                                        fullWidth
                                    />
                                    <TextField
                                        required
                                        name="contactQuery"
                                        label="Consulta"
                                        variant="outlined"
                                        className="input-text"
                                        multiline
                                        rows={4}
                                        value={formData.contactQuery}
                                        onChange={handleChange}
                                    />
                                    <div>
                                        <Button className="send-button"
                                            onClick={sendForm}
                                            disabled={!formData.contactEmail || !formData.contactName || !formData.contactQuery || !formData.contactPhone}
                                        >Enviar</Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="send-success row d-flex justify-content-end bg-light">
                         <Button className="col-1 close-icon" id="redirect-button" onClick={redirect}>
                                <span ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M14.7.423a.905.905 0 0 0-1.205.066L7.631 6.353 1.766.49a.903.903 0 0 0-1.277 0L.423.562A.903.903 0 0 0 .49 1.766l5.864 5.865L.49 13.495a.903.903 0 0 0 0 1.278l.073.066a.902.902 0 0 0 1.204-.066l5.865-5.867 5.864 5.867a.903.903 0 0 0 1.278 0l.066-.074a.902.902 0 0 0-.066-1.204L8.907 7.631l5.866-5.864a.902.902 0 0 0 0-1.277l-.074-.065.001-.002z" fill="#5C157D" />
                                </svg></span>
                            </Button>
                        <div className="container send-success-container">
                            <div className="row">
                                <div className="col d-flex justify-content-center icon-check">
                                    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M44 0c24.3 0 44 19.7 44 44S68.3 88 44 88 0 68.3 0 44 19.7 0 44 0zm0 4C21.909 4 4 21.909 4 44s17.909 40 40 40 40-17.909 40-40S66.091 4 44 4zm18.478 28a2 2 0 0 1 .034 2.828L40.607 57.274a3.001 3.001 0 0 1-4.196.096L25.095 46.792a2 2 0 1 1 2.732-2.922l10.6 9.909 21.222-21.745A2.002 2.002 0 0 1 62.478 32z" fill="#00CE49" />
                                    </svg>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 m-auto text-center mt-4">
                                    <h3>Mensaje enviado</h3>
                                </div>
                            </div>
                            <div className="row">

                                <div className="col-10 col-xl-8 m-auto text-center">
                                    Se enviará la respuesta a la dirección de correo electrónico con la que se ha registrado.
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}